module.exports = __webpack_public_path__ + "img/cafe-glocksee.ff065cf8.png";